export default "__VITE_ASSET__ByyFfaWJ__"